import { BigNumber } from "@ethersproject/bignumber";
import { pipe } from "fp-ts/lib/function";
import * as t from "io-ts";
import * as E from "fp-ts/Either";

export interface BigNumberFromStringC
  extends t.Type<BigNumber, string, unknown> {}

/**
 * @deprecated prefer using BigIntFromString where possible
 */
export const BigNumberFromString: BigNumberFromStringC = new t.Type<
  BigNumber,
  string,
  unknown
>(
  "BigNumberFromString",
  BigNumber.isBigNumber,
  (u, c) =>
    pipe(
      t.string.validate(u, c),
      E.chain((s) => {
        try {
          return t.success(BigNumber.from(s));
        } catch {
          return t.failure(u, c);
        }
      })
    ),
  (bn) => bn.toHexString()
);
export type BigNumberFromString = t.TypeOf<typeof BigNumberFromString>;
